import React from 'react';
import { View, StyleSheet, useWindowDimensions } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { colors } from '_/config/theme';

type LivenessMaskProps = {
  activeLeft: boolean;
  activeRight: boolean;
};

const LivenessMask: React.FC<LivenessMaskProps> = ({ activeLeft, activeRight }) => {
  const rx = 80; // raio horizontal
  const ry = 105; // raio vertical
  const centerX = rx + 20; // margem extra para não cortar
  const centerY = ry + 20; // idem
  const segmentAngle = 80;

  const polarToCartesian = (
    centerX: number,
    centerY: number,
    radiusX: number,
    radiusY: number,
    angleInDegrees: number
  ) => {
    const angleInRadians = (angleInDegrees * Math.PI) / 180.0;
    return {
      x: centerX + radiusX * Math.cos(angleInRadians),
      y: centerY + radiusY * Math.sin(angleInRadians),
    };
  };

  const describeArc = (
    x: number,
    y: number,
    rX: number,
    rY: number,
    startAngle: number,
    endAngle: number
  ) => {
    const start = polarToCartesian(x, y, rX, rY, endAngle);
    const end = polarToCartesian(x, y, rX, rY, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    return `M ${start.x} ${start.y} A ${rX} ${rY} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  };

  const { width, height } = useWindowDimensions();
  const isPortrait = height >= width;

  const frameSize = isPortrait ? width * 0.8 : height * 0.5;

  const translate = frameSize / 2;

  const viewBoxWidth = rx * 2 + 40;
  const viewBoxHeight = ry * 2 + 40;

  return (
    <View
      style={[
        styles.container,
        {
          width: frameSize,
          height: frameSize,
          transform: [{ translateX: -translate }, { translateY: -translate }],
        },
      ]}
    >
      <Svg viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} style={styles.svg}>
        <Path
          stroke={activeRight ? colors.primary : colors.secondary}
          strokeWidth={5}
          fill="none"
          d={describeArc(centerX, centerY, rx, ry, -segmentAngle / 2, segmentAngle / 2)}
        />

        <Path
          stroke={colors.secondary}
          strokeWidth={5}
          fill="none"
          d={describeArc(centerX, centerY, rx, ry, 90 - segmentAngle / 2, 90 + segmentAngle / 2)}
        />

        <Path
          stroke={activeLeft ? colors.primary : colors.secondary}
          strokeWidth={5}
          fill="none"
          d={describeArc(centerX, centerY, rx, ry, 180 - segmentAngle / 2, 180 + segmentAngle / 2)}
        />

        <Path
          stroke={colors.secondary}
          strokeWidth={5}
          fill="none"
          d={describeArc(centerX, centerY, rx, ry, 270 - segmentAngle / 2, 270 + segmentAngle / 2)}
        />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    pointerEvents: 'none',
    zIndex: 6,
  },
  svg: {
    width: '100%',
    height: '100%',
  },
});

export default LivenessMask;
